import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { TitleUnderline } from "./TitleUnderline";
import { formula } from "../data/content";
const barColors = ["bg-blush", "bg-bark-soft", "bg-bark"];
export function Formula() {
  const reduce = useReducedMotion();
  return <section id="methode" aria-labelledby="formula-title" className="flex w-full scroll-mt-24 flex-col justify-center bg-cream md:min-h-[calc(100svh-4rem)]" data-id="element-116" data-mp="1nmaef5dp91c3">
      {/* Tablet: pull content up so the gap to the previous section is halved. */}
      <div aria-hidden="true" className="hidden md:block md:flex-[1] lg:hidden" data-id="element-117" data-mp="vxpbh0nc0ve8" />
      <div className="mx-auto w-full max-w-7xl px-5 py-10 md:px-10 md:pb-6 md:pt-3 lg:py-[3vh]" data-id="element-118" data-mp="19wp3mia1zsf5">
        <div className="max-w-3xl" data-id="element-119" data-mp="14uzpuuvg50nd">
          <h2 id="formula-title" className="font-serif text-4xl font-medium leading-tight text-espresso sm:text-5xl" data-id="element-120" data-mp="2lakl3xofkd9j">
            Woraus eine Schriftstellerin, ein Schriftsteller <TitleUnderline data-id="element-121" data-mp="2gb7y9cxk766y">wirklich</TitleUnderline> gemacht ist
          </h2>
          <p className="mt-5 text-lg font-light leading-relaxed text-cocoa" data-id="element-122" data-mp="1a4cjq4yjvgr0">
            Wer gar kein Talent hat, verspürt auch nicht den Wunsch zu schreiben. Talent ist also nicht das
            Problem – es macht nur einen kleinen Teil aus. Den Großteil kann man lernen.
          </p>
        </div>

        <div className="mt-12 md:mt-8 lg:mt-[7vh]" data-id="element-123" data-mp="1p1wjmxglalqb">
          <div className="flex h-20 w-full overflow-hidden rounded-md sm:h-24" role="img" aria-label="Talent 10 bis 20 Prozent, Handwerkszeug 10 bis 20 Prozent, der Rest ist Disziplin, Dranbleiben und Mindset" data-id="element-124" data-mp="rewj7hmv7oal">
            {formula.map((part, i) => <motion.div key={part.label} initial={reduce ? false : {
            scaleX: 0.9,
            opacity: 0
          }} whileInView={{
            scaleX: 1,
            opacity: 1
          }} viewport={{
            once: true,
            amount: 0.6
          }} transition={{
            duration: 0.3,
            delay: i * 0.06,
            ease: [0.23, 1, 0.32, 1]
          }} style={{
            width: `${part.share}%`,
            transformOrigin: "left"
          }} className={`${barColors[i]} h-full`} data-id="element-125" data-mp="163ak3n0q12oi" data-mpi={i} />)}
          </div>

          {/* Mobile: Talent + Handwerkszeug side by side, the third part below at full width. */}
          <dl className="mt-6 grid grid-cols-2 gap-x-6 gap-y-6 sm:grid-cols-[15fr_15fr_70fr]" data-id="element-126" data-mp="acqon0bqeuah">
            {formula.map((part, i) => <div key={part.label} className={i === 2 ? "col-span-2 sm:col-span-1 sm:pl-4" : ""} data-id="element-127" data-mp="3itlrwgwfygp3" data-mpi={i}>
                <dt className="flex items-center gap-2 text-sm text-taupe" data-id="element-128" data-mp="3dvjxiztkeuyb">
                  <span className={`h-2.5 w-2.5 rounded-full ${barColors[i]}`} aria-hidden="true" data-id="element-129" data-mp="3ssazngumikrm" />
                  {part.label}
                </dt>
                <dd className="mt-1 font-serif text-3xl text-espresso" data-id="element-130" data-mp="3nuj9osdjh8q2">
                  {part.range}
                </dd>
              </div>)}
          </dl>
        </div>

        <p className="mt-12 max-w-2xl border-l-2 border-blush pl-6 font-serif text-2xl italic leading-snug text-cocoa md:mt-8 lg:mt-[7vh]" data-id="element-131" data-mp="131o28q5002ww">
          Genau dort setze ich an. Nicht nur beim Wissen über Plot und Figuren, sondern auch bei dem, was Dich dranbleiben lässt.
        </p>
      </div>
      <div aria-hidden="true" className="hidden md:block md:flex-[3] lg:hidden" data-id="element-132" data-mp="11mlgc41p0fn6" />
    </section>;
}